


















import { Vue, Component } from 'vue-property-decorator'
import VueBase from '@/lib/vuebase'
import ajax from '@/lib/ajax'
import util from '@/lib/util'
import AssignChangeDto from '@/store/models/maintain/assignChange'
@Component({})
export default class DispatchChange extends VueBase {
	showAssignBy: boolean = false
	assignByList: Array<any> = []
	assignBys: any = []
	assignBy: string = ''
	assignChange: AssignChangeDto = new AssignChangeDto()
	id!: any
	onClickLeft() {
		window.history.go(-1)
	}
	async getAssignByList() {
		await ajax.get('/api/maintainrecord/assign-change-by-list')
			.then(rep => {
				this.assignByList.push(...rep.data.result)
			})
	}
	onConfirmAssignBy(val: any) {
		this.assignBys = this.assignBys
		this.assignBy = this.assignBys.join(',')
		this.showAssignBy = false
	}
	async submit() {
		this.assignChange.maintainRecordId = this.id
		this.assignChange.assignBys = this.assignBys
		await ajax.post('/api/maintainrecord/maintain-record-assign-change', this.assignChange)
			.then(() => {
				this.$toast.success('转派成功')
				window.history.back()
			})
	}
	async created() {
		await this.getAssignByList()
		this.id = this.$route.query.id
	}
}
